import axios from 'axios';

// API Base URL - wird später mit der WordPress-Umgebung konfiguriert
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost/wp-json/casino-bonus/v1';

// Axios instance mit Konfiguration
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Fetch all casinos with optional filters
export const fetchCasinos = async (filters = {}) => {
  try {
    const response = await apiClient.get('/casinos', {
      params: filters,
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching casinos:', error);
    // Fallback zu Mock-Daten während der Entwicklung
    return getMockCasinos();
  }
};

// Fetch single casino by ID
export const fetchCasinoById = async (id) => {
  try {
    const response = await apiClient.get(`/casinos/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching casino:', error);
    throw error;
  }
};

// Fetch single casino by its slug ("Kürzel") – used by the offer detail page
export const fetchCasinoBySlug = async (slug) => {
  const response = await apiClient.get(`/casinos/slug/${encodeURIComponent(slug)}`);
  return response.data;
};

// Track affiliate click
export const trackAffiliateClick = async (casinoId) => {
  try {
    await apiClient.post('/track-click', { casino_id: casinoId });
  } catch (error) {
    console.error('Error tracking click:', error);
  }
};

// Fetch social links
export const fetchSocialLinks = async () => {
  try {
    const response = await apiClient.get('/social-links');
    return response.data;
  } catch (error) {
    console.error('Error fetching social links:', error);
    return [];
  }
};

// Fetch branding settings
export const fetchBranding = async () => {
  try {
    const response = await apiClient.get('/branding');
    return response.data;
  } catch (error) {
    console.error('Error fetching branding:', error);
    return {
      logoUrl: 'https://mobonus.com/wp-content/uploads/2025/11/Logo2.png',
      faviconUrl: '',
      backgroundImage: '',
      backgroundSize: 'cover',
      backgroundPosition: 'center center',
      backgroundOpacity: 0.05
    };
  }
};

// Fetch navigation links
export const fetchNavLinks = async () => {
  try {
    const response = await apiClient.get('/nav-links');
    return response.data;
  } catch (error) {
    console.error('Error fetching navigation links:', error);
    return [];
  }
};

// Fetch general settings
export const fetchGeneralSettings = async () => {
  try {
    const response = await apiClient.get('/settings');
    return response.data;
  } catch (error) {
    console.error('Error fetching general settings:', error);
    return {
      showRatingsAndProcons: true
    };
  }
};

// Mock data für Entwicklung und Tests
const getMockCasinos = () => {
  return [
    {
      id: 1,
      name: 'Lucky Spin Casino',
      logo: null,
      rating: 5,
      bonusAmount: 500,
      bonusType: 'welcome',
      wageringRequirement: 35,
      minDeposit: 10,
      validDays: 30,
      featured: true,
      features: [
        'Über 2000 Spiele',
        'Schnelle Auszahlungen',
        'Live Casino',
        '24/7 Support'
      ],
      description: 'Lucky Spin Casino bietet einen großzügigen Willkommensbonus und eine riesige Auswahl an Spielen. Perfekt für neue Spieler!',
      affiliateLink: '#',
      createdAt: '2024-01-15'
    },
    {
      id: 2,
      name: 'Royal Vegas',
      logo: null,
      rating: 4,
      bonusAmount: 300,
      bonusType: 'deposit',
      wageringRequirement: 30,
      minDeposit: 20,
      validDays: 21,
      featured: true,
      features: [
        'Exklusive Slots',
        'VIP Programm',
        'Mobile App',
        'Crypto Zahlungen'
      ],
      description: 'Royal Vegas ist bekannt für seine exklusiven Slot-Spiele und das attraktive VIP-Programm.',
      affiliateLink: '#',
      createdAt: '2024-01-14'
    },
    {
      id: 3,
      name: 'Golden Palace',
      logo: null,
      rating: 5,
      bonusAmount: 750,
      bonusType: 'welcome',
      wageringRequirement: 40,
      minDeposit: 25,
      validDays: 14,
      featured: false,
      features: [
        'Höchster Bonus',
        'Premium Spiele',
        'Tägliche Aktionen',
        'Cashback Programm'
      ],
      description: 'Golden Palace bietet den höchsten Willkommensbonus auf dem Markt mit erstklassigen Spielen.',
      affiliateLink: '#',
      createdAt: '2024-01-13'
    },
    {
      id: 4,
      name: 'Mega Slots',
      logo: null,
      rating: 4,
      bonusAmount: 200,
      bonusType: 'freespins',
      wageringRequirement: 25,
      minDeposit: 10,
      validDays: 7,
      featured: false,
      features: [
        '100 Freispiele',
        'Keine Einzahlung nötig',
        'Sofortauszahlung',
        'Top Slots'
      ],
      description: '100 Freispiele ohne Einzahlung! Mega Slots bietet dir die Chance, ohne Risiko zu gewinnen.',
      affiliateLink: '#',
      createdAt: '2024-01-12'
    },
    {
      id: 5,
      name: 'Diamond Casino',
      logo: null,
      rating: 5,
      bonusAmount: 1000,
      bonusType: 'welcome',
      wageringRequirement: 45,
      minDeposit: 50,
      validDays: 30,
      featured: true,
      features: [
        'Bis zu 1000€ Bonus',
        'Premium Live Casino',
        'Persönlicher VIP Manager',
        'Wöchentliche Boni'
      ],
      description: 'Diamond Casino ist die erste Wahl für High Roller mit exklusiven VIP-Angeboten.',
      affiliateLink: '#',
      createdAt: '2024-01-11'
    },
    {
      id: 6,
      name: 'Jackpot City',
      logo: null,
      rating: 4,
      bonusAmount: 400,
      bonusType: 'deposit',
      wageringRequirement: 30,
      minDeposit: 15,
      validDays: 21,
      featured: false,
      features: [
        'Progressive Jackpots',
        'Tägliche Turniere',
        'Reload Bonus',
        'Treueprogramm'
      ],
      description: 'Jackpot City ist spezialisiert auf progressive Jackpots mit Millionen-Gewinnen.',
      affiliateLink: '#',
      createdAt: '2024-01-10'
    },
    {
      id: 7,
      name: 'Phoenix Slots',
      logo: null,
      rating: 4,
      bonusAmount: 250,
      bonusType: 'cashback',
      wageringRequirement: 20,
      minDeposit: 20,
      validDays: 30,
      features: [
        '20% Cashback',
        'Keine Limits',
        'Sofortauszahlung',
        'Alle Spiele'
      ],
      description: 'Phoenix Slots bietet 20% Cashback auf alle Verluste - ein Sicherheitsnetz für dein Spiel.',
      affiliateLink: '#',
      createdAt: '2024-01-09'
    },
    {
      id: 8,
      name: 'Casino Royale',
      logo: null,
      rating: 5,
      bonusAmount: 600,
      bonusType: 'welcome',
      wageringRequirement: 35,
      minDeposit: 30,
      validDays: 28,
      featured: false,
      features: [
        'James Bond Thema',
        'Exklusive Tische',
        'High Stakes',
        'Luxus VIP Club'
      ],
      description: 'Casino Royale bringt den Glamour von James Bond direkt zu dir nach Hause.',
      affiliateLink: '#',
      createdAt: '2024-01-08'
    }
  ];
};

export default apiClient;
